function requireAuth(to, from, next) {
  var _this = this;

  $.ajax({
    url: api_url + 'users/checkLogin',
    method: 'post',
    dataType: 'json',
    success: function (response) {
      if (response.success) {
        vue.user = response.user;
        next();
      } else {
        vue.targetPath = to.fullPath;
        console.log(to.fullPath);
        next({
          path: '*'
        });
        vue.openLoginPopup();
      }
    }
  });
}

function loadAndSetUser(to, from, next) {
  $.ajax({
    url: api_url + 'users/get_from_session',
    method: 'get',
    dataType: 'json',
    success: function (response) {
      if (response.user != false)
        vue.user = response.user;

      next();
    }
  });
}

import Vue from 'vue';
import VueRouter from 'vue-router';
import components from './components/components.vue';
import App from './components/app.vue'
import Home from './components/home.vue';
import Search from './components/search.vue';
import Message from './components/message.vue';
import Informaciok from './components/informaciok.vue';
import UserPage from './components/userpage.vue';
import HatarAdmin from './components/hatar_admin.vue';
import Competition from './components/competition.vue';
import CompetitionForm from './components/competition/form.vue';
import ProfilePage from './components/profilepage.vue';
import Contact from './components/contact.vue';
import Uploads from './components/uploads.vue';
import NemzetiFelsooktatasiOsztondijHianypotlas from './components/competition/nemzeti_felsooktatasi_osztondij_hianypotlas.vue';
import UtanpotlasHallgatoiOsztondijHianypotlas from './components/competition/utanpotlas_hallgatoi_osztondij_hianypotlas.vue';
import UnkpHianypotlas from './components/competition/unkp_hianypotlas.vue';
import Unkp2021Hianypotlas from './components/competition/unkp2021_hianypotlas.vue';
import Unkp2022Hianypotlas from './components/competition/unkp2022_hianypotlas.vue';
import Unkp2023Hianypotlas from './components/competition/unkp2023_hianypotlas.vue';
import EKOP2024Hianypotlas from './components/competition/ekop2024_hianypotlas.vue';
import EKOP2025Hianypotlas from './components/competition/ekop2025_hianypotlas.vue';
import DoktoriProgram from './components/competition/doktori_program.vue';
import RendkivuliSzocialisOsztondij from './components/competition/rendkivuli_szocialis_osztondij.vue';

Vue.use(VueRouter)

const router = new VueRouter({
  base: __dirname,
  // mode: 'history',
  routes: [
    { path: '*', component: Home },
    { path: '/home', component: Home },
    { path: '/search', component: Search, beforeEnter: requireAuth },
    { path: '/informaciok', component: Informaciok, beforeEnter: loadAndSetUser },
    { path: '/feltoltesek/:filename', component: Uploads, beforeEnter: requireAuth },
    { path: '/userpage', component: UserPage, beforeEnter: requireAuth },
    { path: '/msg', component: Message, beforeEnter: loadAndSetUser },
    { path: '/hatar_admin', component: HatarAdmin, beforeEnter: requireAuth },
    { path: '/palyazatok', redirect: '/palyazatok/osztondij' },
    { path: '/palyazatok/:page', component: Competition },
    { path: '/palyazatok/:page/:form', component: Competition, beforeEnter: requireAuth },
    { path: '/palyazatra_jelentkezes', component: CompetitionForm, beforeEnter: requireAuth },
    { path: '/profil', component: ProfilePage, beforeEnter: requireAuth },
    { path: '/kapcsolat', component: Contact, beforeEnter: loadAndSetUser },
    { path: '/nemzeti_felsooktatasi_osztondij_hianypotlas', component: NemzetiFelsooktatasiOsztondijHianypotlas, beforeEnter: requireAuth },
    { path: '/utanpotlas_hallgatoi_osztondij_hianypotlas', component: UtanpotlasHallgatoiOsztondijHianypotlas, beforeEnter: requireAuth },
    { path: '/unkp_hianypotlas', component: UnkpHianypotlas, beforeEnter: requireAuth },
    { path: '/unkp2021_hianypotlas', component: Unkp2021Hianypotlas, beforeEnter: requireAuth },
    { path: '/unkp2022_hianypotlas', component: Unkp2022Hianypotlas, beforeEnter: requireAuth },
    { path: '/unkp2023_hianypotlas', component: Unkp2023Hianypotlas, beforeEnter: requireAuth },
    { path: '/ekop2024_hianypotlas', component: EKOP2024Hianypotlas, beforeEnter: requireAuth },
    { path: '/ekop2025_hianypotlas', component: EKOP2025Hianypotlas, beforeEnter: requireAuth },
    { path: '/doktori_program', component: DoktoriProgram, beforeEnter: requireAuth },
    { path: '/rendkivuli_szocialis_osztondij', component: RendkivuliSzocialisOsztondij, beforeEnter: requireAuth },
  ]
});

window.api_url = 'api/';

var vue = new Vue({
  data: {
    version: '1.0.2025.06.23.14.00',
    user: '',
    tmpLoginOpen: false,
    shibbolethLoginOpen: false,
    targetPath: '/home',
    pageMsg: {
      type: '',
      text: ''
    },
    socket: ''
  },
  mounted: function () {
    const _this = this;

    // Bugfix for: Vue lifecycle events not triggering in Internet Explorer
    if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) { // detect it's IE11
      window.addEventListener('hashchange', function () {
        var currentPath = window.location.hash.slice(1);
        if (_this.$route.path !== currentPath) {
          _this.$router.push(currentPath);
        }
      }, false)
    }

    $.ajax({
      url: api_url + 'users/checkLogin',
      method: 'post',
      dataType: 'json',
      success: function (response) {
        if (response.success) {
          vue.user = response.user;
        }
      }
    });
  },
  methods: {
    openTmpLogin() {
      this.tmpLoginOpen = true;
      $('body').addClass('oh');
    },

    closeTmpLogin() {
      this.tmpLoginOpen = false;
      $('body').removeClass('oh');
    },

    openLoginPopup: function () {
      const _this = this;

      if (process.env.NODE_ENV == 'development') {
        this.openTmpLogin();

      } else if (process.env.NODE_ENV == 'production') {
        var shibwindow = window.open(location.protocol + "//" + location.host + "/Shibboleth.sso/Login?target=" + location.protocol + "//" + location.host + "/api/users/shib_login", 'Bejelentkezés', 'status=1, toolbar=0, width=800, height=720');

        if (shibwindow != null) {
          this.shibbolethLoginOpen = true;

          var shibTimer = setInterval(() => {
            if (shibwindow.closed) {
              clearInterval(shibTimer);

              _this.shibbolethLoginOpen = false;

              if (shibwindow.response != undefined && shibwindow.response != '' && typeof shibwindow.response == 'object') {
                if (shibwindow.response.status == 'OK') {
                  _this.user = shibwindow.response.user;
                  _this.$router.push({ path: _this.targetPath });

                } else if (shibwindow.response.status == 'ERROR') {
                  swal('Hiba', shibwindow.response.msg, 'error');
                }
              }
            }
          }, 500);
        }
      }
    },

    logout: function () {
      var _this = this;

      this.$root.ajax('users/logout', {
        method: 'GET',
        success: function (response) {
          _this.user = '';
          _this.$router.push({ path: '/home' });

          if (process.env.NODE_ENV == 'production') {
            $.ajax(location.protocol + '//' + location.host + '/Shibboleth.sso/Logout?return=' + location.protocol + '//' + location.host);
          }
        }
      });
    },
    ajax: function (url, user_options) {
      var _this = this;

      // Verzió ellenőrzés
      $.ajax({
        url: api_url + 'checkVersion',
        method: 'post',
        data: {
          version: _this.version
        },
        dataType: 'json',
        success: function (response) {
          if (response.status == 'ERROR') {
            swal('Figyelem', response.msg, 'error');
            return;
          } else {
            _this.callajax(url, user_options);
          }
        }
      });
    },
    nl2br: function (text) {
      return text.replace(/(?:\r\n|\r|\n)/g, '<br />');
    },
    callajax: function (url, user_options) {
      var _this = this;

      var options = {
        method: 'GET',
        dataType: 'json',
        data: {},
        async: true,
        success: function () { },
        error: function () { }
      };

      var options = $.extend({}, options, user_options);

      try {
        if (url == undefined)
          throw 'Url hiányzik';

        $.ajax({
          method: options.method,
          url: api_url + url,
          async: options.async,
          data: options.data,
          timeout: 1800000,
          dataType: options.dataType,
          error: options.error,
          beforeSend: options.beforeSend ? options.beforeSend : () => { },
          success: function (response) {
            if (response.status == "OK") {
              options.success(response);

            } else if (response.status == "NO_ACCESS") {
              _this.$data.pageMsg = {
                type: 'alert alert-danger',
                text: 'Nincs joga a művelethez'
              };
              _this.$router.push({ path: '/msg' });

            } else if (response.status == "DATABASE_ERROR") {
              _this.$data.pageMsg = {
                type: 'alert alert-danger',
                text: response.text
              };
              _this.$router.push({ path: '/msg' });
            }
          }
        });

      } catch (error) {
        alert(error);
      }
    },
    guid: function () {
      function rdchar() {
        var s = 'abcdefghijklmnopqrstuvwxyz';
        var c = s.charAt(Math.floor(Math.random() * s.length));
        return c;
      }

      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return rdchar() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    },
  },
  router,
  render: h => h(App)
}).$mount('#app-container');



// WEBPACK FOOTER //
// ./main.js